import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Toast {
  id: number;
  type: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message: string;
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;
  private toastSubject = new Subject<Toast>();
  toast$ = this.toastSubject.asObservable();

  show(type: Toast['type'], title: string, message: string, duration = 4000): void {
    const toast: Toast = {
      id: ++this.counter,
      type,
      title,
      message,
      duration,
    };
    this.toastSubject.next(toast);
  }

  success(titleOrMessage: string, message?: string, duration = 4000): void {
    const title = message !== undefined ? titleOrMessage : 'Success';
    const msg = message !== undefined ? message : titleOrMessage;
    this.show('success', title, msg, duration);
  }

  error(titleOrMessage: string, message?: string, duration = 5000): void {
    const title = message !== undefined ? titleOrMessage : 'Error';
    const msg = message !== undefined ? message : titleOrMessage;
    this.show('error', title, msg, duration);
  }

  info(titleOrMessage: string, message?: string, duration = 4000): void {
    const title = message !== undefined ? titleOrMessage : 'Information';
    const msg = message !== undefined ? message : titleOrMessage;
    this.show('info', title, msg, duration);
  }

  warning(titleOrMessage: string, message?: string, duration = 4500): void {
    const title = message !== undefined ? titleOrMessage : 'Warning';
    const msg = message !== undefined ? message : titleOrMessage;
    this.show('warning', title, msg, duration);
  }

  dismiss(id: number): void {
    this.toastSubject.next({ id, type: 'info', title: '', message: '' } as any);
  }
}
